export function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber || typeof phoneNumber !== 'string') return phoneNumber;

    // Remove qualquer caractere não numérico
    phoneNumber = phoneNumber.replace(/\D/g, '');

    // Verifica se o número tem 11 dígitos
    if (phoneNumber.length === 11) {
        // Formata o número para o padrão (XX) XXXXX-XXXX
        return phoneNumber.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } else {
        // Retorna o número original se não tiver 11 dígitos
        return phoneNumber;
    }
}